import React from "react";
import PropTypes from "prop-types";
import { useSolrContext } from "@e-fork/solr";
import NoResults from "../components/system/no-results";
import Loading from "../components/system/loading";
import Error from "../components/system/error";
import Pagination from "../components/system/pagination";
import EndlessScroll from "../components/system/endless-scroll";
import Filters from "../components/filters";
import TeaserBase from "@default/teasers/teaser-base";
import TeaserSpeaker from "@default/teasers/speaker/teaser-speaker";
import speakerSchemaMapper from "@default/teasers/speaker/speaker-schema-mapper";
import { getGroupId } from "../components/filters/facet-types/scroll-to-facet";
import useStickyFilterVanish from "@default/hooks/use-sticky-filter-vanish";
import FiltersControlFacet from "../components/filters/filters-control-facet";
import FiltersControlSearch from "../components/filters/filters-control-search";

const OverviewSpeakers = ({ content }) => {
  // Get relevant values from the OverviewContext.
  const { items, error, config } = useSolrContext();
  const { sentinelRef, filterWrapperRef } = useStickyFilterVanish();
  const firstLetterFacet = config.facets.find(
    (f) => f?.id === "participants_first_letter"
  );

  return (
    <section
      className={`paragraph paragraph-overview overview-solr type-${content.fieldContentType}`}
    >
      <div ref={sentinelRef} />
      <div className="sticky-wrapper filter-wrapper" ref={filterWrapperRef}>
        <div className="main-container d-flex gap-sm">
          {firstLetterFacet && <FiltersControlFacet {...firstLetterFacet} />}
          {config.search && <FiltersControlSearch />}
        </div>
      </div>
      <div className="container no-padding">
        {!!items?.length &&
          !error &&
          items.map((item, idx) => (
            <div
              className="row"
              key={item.id}
              id={getGroupId(item.first_letter)}
            >
              <div className="col-12">
                <TeaserSpeaker item={speakerSchemaMapper(item)} />
              </div>
            </div>
          ))}

        <div className="row">
          <div className="col-12">
            <NoResults />
            <Loading />
            <Error />
          </div>
        </div>
      </div>

      {config.pageMode === "pager" && <Pagination />}
      {config.pageMode === "endless" && <EndlessScroll />}
    </section>
  );
};

OverviewSpeakers.propTypes = {};

export default OverviewSpeakers;
